import request from '@/config/axios'

export interface McpAssistantRouteResultVO {
  matched: boolean
  mcpCode?: string
  reason?: string
  confidence?: number
}

export interface McpAssistantProfileVO {
  code: string
  name: string
  description: string
  examples: string[]
  tools: string[]
}

export interface McpAssistantConfigVO {
  id?: number
  mcpCode: string
  enabled: boolean
  triggerDesc?: string
  triggerExamples?: string
}

export const McpAssistantRouteApi = {
  route: async (message: string): Promise<McpAssistantRouteResultVO> =>
    request.post({ url: '/ai/mcp-assistant/route', data: { message } }),
  profiles: async (): Promise<McpAssistantProfileVO[]> =>
    request.post({ url: '/ai/mcp-assistant/profiles' })
}

export const McpAssistantConfigApi = {
  list: async (): Promise<McpAssistantConfigVO[]> =>
    request.get({ url: '/ai/mcp-assistant/config/list' }),
  save: async (data: McpAssistantConfigVO): Promise<number> =>
    request.put({ url: '/ai/mcp-assistant/config/save', data })
}
